module.exports = __webpack_public_path__ + "media/images/hero/hero1-house-roof-fae6b7c9226e695acc906f731e400205.svg";